import { ReactComponent as VIcon } from '@elementary/common-ui/assets/v-green.svg';
import {
  Alert,
  Flex,
  FlexColumn,
  FormField,
  LoadingButton,
  PasswordField,
} from '@elementary/common-ui/components';
import { Typography } from '@mui/material';

type Props = {
  apiKey: string;
  apiSecret: string;
  onApiKeyChange: (value: string) => void;
  onApiSecretChange: (value: string) => void;
  onConnect: () => void;
  isConnecting: boolean;
  isConnected: boolean;
  errorMessage?: string;
  apiKeyPlaceholder?: string;
  apiSecretPlaceholder?: string;
};

const FivetranCredentialsSection = ({
  apiKey,
  apiSecret,
  onApiKeyChange,
  onApiSecretChange,
  onConnect,
  isConnecting,
  isConnected,
  errorMessage,
  apiKeyPlaceholder,
  apiSecretPlaceholder,
}: Props) => {
  const canConnect = !!apiKey.trim() && !!apiSecret.trim() && !isConnecting;

  return (
    <FlexColumn sx={{ gap: 2 }}>
      <FormField title="API key">
        <PasswordField
          size="large"
          fullWidth
          autoComplete="off"
          value={apiKey}
          placeholder={apiKeyPlaceholder ?? 'Enter your API key'}
          onChange={(event) => onApiKeyChange(event.target.value)}
        />
      </FormField>

      <FormField title="API secret">
        <PasswordField
          size="large"
          fullWidth
          autoComplete="off"
          value={apiSecret}
          placeholder={apiSecretPlaceholder ?? 'Enter your API secret'}
          onChange={(event) => onApiSecretChange(event.target.value)}
        />
      </FormField>

      <Flex sx={{ alignItems: 'center', gap: 2 }}>
        <LoadingButton
          variant="outlined"
          color="secondary"
          onClick={onConnect}
          loading={isConnecting}
          loadingPosition="center"
          disabled={!canConnect}
        >
          Connect
        </LoadingButton>
        {isConnected && !isConnecting && (
          <Flex sx={{ alignItems: 'center', gap: 1 }}>
            <VIcon width={16} />
            <Typography sx={{ color: 'common.green' }}>
              Connection verified
            </Typography>
          </Flex>
        )}
      </Flex>

      {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
    </FlexColumn>
  );
};

export default FivetranCredentialsSection;
